import React from 'react'
import Navbar from "../../components/Navbar/Navbar"
import Footer from  "../../components/Footer/Footer"
import ShowRoomBaghdadHero from '../../components/ShowRoomBaghdadHero/ShowRoomBaghdadHero'
import ShowRoomBaghdadLocation from '../../components/ShowRoomBaghdadLocation/ShowRoomBaghdadLocation'
import ShowRoomBaghdadArt from '../../components/ShowRoomBaghdadArt/ShowRoomBaghdadArt'

const ShowRoomBaghdad = () => {
  return (
    <div>
      <Navbar/>
      <ShowRoomBaghdadHero/>
      <ShowRoomBaghdadLocation/>
      <ShowRoomBaghdadArt/>
      <Footer/>
    </div>
  )
}

export default ShowRoomBaghdad
